import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { delay: { type: Number, default: 3000 } }

  buttonTargetConnected() {
    this.clearTimer()
    const isSuccess = this.element.classList.contains('alert-success')
    const isFloating = this.element.classList.contains('sa-alert-flash')
    if (!isSuccess && !isFloating) { return }

    const delay = isSuccess ? this.delayValue : this.delayValue * 3
    this.timer = setTimeout(() => {
      try { this.buttonTarget.click() } catch (_e) {}
    }, delay)
  }

  disconnect() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.timer) { clearTimeout(this.timer); this.timer = null }
  }
}
